import React, { useEffect, useState } from 'react';
import Slider from 'react-slick/lib/slider';
// import img_laptop from '../../assets/images/online_gambling.png';
import { useNavigate } from "react-router-dom";
import { GetAllBanner, GetAllFreeTips } from '../../Redux/Auth/Auth_Action';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';


const TopSlider = () => {

    let arr = [0, 1, 2];
    const selector = useSelector((state) => state.Auth.user);
    // console.log('top Slider',selector.id);
    const [state, setState] = useState({ tipData: [] });
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const routeChange = () => {
        let path = `tips`;
        navigate(path);
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                // className='Slider_top_custom_arrows-next'
                style={{ ...style, display: "none", background: "red", height: "80px", width: "80px" }}
                onClick={onClick}
            />
        );
    }

    function SamplePrevArrow(props) {
        const { style, onClick } = props;
        return (
            <div
                // className="Slider_top_custom_arrows"
                style={{ ...style, display: "none", background: "green", height: "80px", width: "80px" }}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,

        appendDots: dots => (
            <div
                style={{
                    // backgroundColor: "black",
                    borderRadius: "10px",
                    color: "white",
                    padding: "10px"
                }}
            >
                <ul style={{ margin: "0px" }}> <span style={{ color: "white" }}>{dots}</span> </ul>
            </div>
        ),
    };

    const getFreeTips = () => {
        // console.log("selector id", selector.id)
        // dispatch(GetAllFreeTips())
        dispatch(GetAllBanner())
            .then((res) => {
                // console.log("res from top slider home", res.data.response.data);
                setState({ ...state, tipData: res.data.response.data });
                // console.log("reszzzzzzzzzzzzz",res.data.response.data)
            })
            .catch((e) => {
                toast.error("Network Error");
            })
    }

    useEffect(() => {
        getFreeTips();
    }, [])

    return (
        <div className='top_slider pb_home_200'>
            <div className='row'>
                <div className='col-lg-12'>
                    <Slider {...settings} className="slider_top_home">
                        {state?.tipData?.slice(0, 3)?.map((item, index) => {
                            // console.log("item from slider", item);
                            return (
                                <div key={index}>
                                    <div className='row'>
                                        <div className='col-lg-6 pl-3'>
                                            {/* clr-e0 */}
                                            <p className='text-white f-24 mb-0 f-mon-bold'>GET  <span className='clr-e0 txt-captl'>SPORTS BETTING TIPS</span> TODAY </p>
                                            <p className='text-white f-18 mb-0 f-mon-light txt-captl'>START WINNING TODAY</p>
                                            <p className='text-white f-18 f-mon-bold mb-0'> <span className=' pb-2 mb-3 text-white'> AND   </span><span className='clr-e0 txt-captl'>Ready To Get Into The Action ?</span> </p>
                                            <p className='text-white f-18 mb-0 f-mon-light txt-captl'>
                                                Do you want start building your bankroll?
                                            </p>
                                            <p className='text-white mt-4 f-18 mb-0 f-mon-light txt-captl'>
                                                {item.heading}
                                            </p>
                                            <p className='text-white mt-4 f-18 f-mon-light pt-2 mb-3 ' >{item.description}</p>
                                            <button onClick={routeChange} className='btn btn-light f-16 f-mon-reg btn-pink-now mb-5 mt-3 txt-captl'>Get Your Complimentary Pick</button>
                                        </div>
                                        <div className='col-lg-6'>
                                            {(item.media_url.slice(-3) === "mp4")
                                                ?
                                                <video className='vido_home' loop width="100%" height="" controls={false} autoPlay muted>
                                                    <source src={`${item?.media_url}`} type="video/mp4" />
                                                </video>
                                                :
                                                <div style={{ backgroundImage: `url('${item?.media_url}')` }} className='bg-slider-image-top'>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    )
}

export default TopSlider;